import api from "@/lib/api";

/** @param {string} [context] */
export async function getCurrentLegalDocuments(context = "license_request") {
  const { data } = await api.get("/commercial/legal-documents/current", {
    params: { context },
  });
  return data;
}

/** @param {object} payload */
export async function createAgreementAcceptance(payload) {
  const { data } = await api.post("/commercial/agreement-acceptances", payload);
  return data;
}

/** @returns {Promise<object[]>} */
export async function listMyAgreementAcceptances() {
  const { data } = await api.get("/commercial/agreement-acceptances/me");
  return data?.items || [];
}

/**
 * @param {{ requested_modules?: Record<string, boolean> }} [params]
 * @returns {Promise<{ reusable: boolean, requires_new_acceptance: boolean, acceptance?: object, agreement_acceptance_id?: string, contract_version?: string, accepted_at?: string, reason?: string }>}
 */
export async function getApplicableAgreementAcceptance(params = {}) {
  const mods = params.requested_modules || {};
  const hasMods = Object.values(mods).some(Boolean);
  const { data } = await api.get("/commercial/agreement-acceptances/me/applicable", {
    params: hasMods ? { requested_modules: JSON.stringify(mods) } : {},
  });
  return data;
}

/** @param {string} id */
export async function getAgreementAcceptance(id) {
  const { data } = await api.get(`/commercial/agreement-acceptances/${id}`);
  return data;
}
